import { useMemo } from "react";

export default function SettingName({ setting, className = '' }) {
  const shortName = useMemo(() => {
    let temp = setting?.name;
    if (setting?.slug?.endsWith('-regular')) {
      temp += ' 👤';
    } else if (setting?.slug?.endsWith('-leadership')) {
      temp += ' 👔';
    }
    return temp;
  }, [setting]);

  return <span
    className={`${className}`}
    data-tooltip-id="setting-name-tooltip"
    data-tooltip-content={setting?.name + ` (${setting?.description})`}>
    {shortName}
  </span>;
}